import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RegexService {

  number = /^[\d]+$/;
  english = /^[a-zA-Z]+$/;
  special = /^[!@#$%^&*_]+$/;
  numberEnglishSpecial = /^[0-9a-zA-Z!@#$%^&*_]+$/;

  constructor() { }

  replace = {
    number: (number:string | number) => {
      return String(number).replace(/[^\d]/g, "");
    },
    price: (number:string | number) => {
      let sNumber = String(number);
      let sNumber_2 = [];
      if(sNumber.indexOf('.') != -1){
        sNumber_2 = sNumber.split('.');
        let str = sNumber_2[0].replace(/[^0-9]/g, '');
        let price = str.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        return sNumber.startsWith('-') ? '-' + price + '.' + sNumber_2[1] : price + '.' + sNumber_2[1];
      } else {
        let str = sNumber.replace(/[^0-9]/g, '');
        let price = str.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        return sNumber.startsWith('-') ? '-' + price : price;
      }
    },
    phone: (number:string | number) => {
      return String(number).replace(/(\d{3})(\d{3,4})(\d{0,4})/, "$1-$2-$3");
    },
    date: (number:string | number) => {
      return String(number).replace(/(\d{4})(\d{2})(\d{0,2})/, "$1-$2-$3");
    },
    companyLicenseNo: (number:string | number) => {
      return String(number).replace(/(\d{3})(\d{2})(\d{0,5})/, "$1-$2-$3");
    }
  }
}
